import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '@/lib/auth';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading } = useAuth();
  const location = useLocation();

  console.log('[ProtectedRoute] loading:', loading, 'user:', user?.email, 'verified:', user?.email_confirmed_at, 'path:', location.pathname);

  if (loading) {
    console.log('[ProtectedRoute] Showing loading spinner');
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin text-4xl mb-4">🌿</div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    console.log('[ProtectedRoute] No user, redirecting to /login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if email is verified
  if (!user.email_confirmed_at) {
    console.log('[ProtectedRoute] User not verified, redirecting to /verify-email');
    return <Navigate to="/verify-email" replace />;
  }

  console.log('[ProtectedRoute] User authenticated and verified, rendering children');
  return <>{children}</>;
}